import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as applicationActions from "../../actions/application";
import ImageButtonList from "../common/imageButtonList";
import ImageText from "../common/imageText";
import NavigationBar from "../common/navigationBar";

class FeedbackList extends Component {
  /**************
   * Properties *
   **************/
  state = {
    buttons: [
      {
        id: "admission",
        to: "/feedback/question/" + this.props.currentPatient + "Admission/1",
        highlight: require("./images/Intro_Admission_HL.png"),
        unhighlight: require("./images/Intro_Admission_UH.png"),
        checked: this.props.submitted === "admission",
      },
      {
        id: "ratemycare",
        to: "/feedback/question/" + this.props.currentPatient + "Rating/1",
        highlight: require("./images/1210_Intro_RateMyCare_HL.png"),
        unhighlight: require("./images/1210_Intro_RateMyCare_UH.png"),
        checked: this.props.submitted === "rating",
      },
      {
        id: "discharge",
        highlight: require("./images/Intro_Discharge_HL.png"),
        unhighlight: require("./images/Intro_Discharge_UH.png"),
      },
      {
        id: "hospitalService",
        highlight: require("./images/Intro_HospServ_HL.png"),
        unhighlight: require("./images/Intro_HospServ_UH.png"),
      },
      {
        id: "televisionUsage",
        highlight: require("./images/Intro_TVUsage_HL.png"),
        unhighlight: require("./images/Intro_TVUsage_UH.png"),
      },
    ],
    textImage: require("./images/1210_elements_intro.png"),
    selectImage: require("./images/1210_btn_select_intro.png"),
    navigationBar: {
      back: true,
      backRoute: "/main_menu",
      mainMenu: true,
      navigate: true,
    },
  };

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="feedback-list">
        <ImageText id="text" src={this.state.textImage} />
        <ImageButtonList
          imageButtons={this.state.buttons}
          flexClass="flex-vertical"
        />
        <img className="btn-select" src={this.state.selectImage} alt="" />
        <NavigationBar {...this.state.navigationBar} />
      </div>
    );
  }
}

const ConnectedFeedbackList = connect(
  (state) => ({
    context: state.application.currentContext,
    currentPatient: state.application.currentPatient,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(FeedbackList);

export default withRouter(ConnectedFeedbackList);
